// extracted by mini-css-extract-plugin
export default {"TextSlider":"TextSlider_TextSlider__rI4i7"};